import script from "./ReportDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./ReportDetails.vue?vue&type=script&setup=true&lang=js"

import "./ReportDetails.vue?vue&type=style&index=0&id=db1f4304&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-db1f4304"]])

export default __exports__